// วางเนื้อหาลงแถบบน (เช่น ตัวเลือกโมเดลของหน้าแชท)
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

export default function TopbarSlot({ children }) {
  const [el, setEl] = useState(null);
  useEffect(() => setEl(document.getElementById("topbar-slot")), []);
  return el ? createPortal(children, el) : null;
}
